<template>
  <BaseNode v-bind="props" class="scheduling-note-node">
    <template #header>
      <BaseHtmlContent class="node__title" :html="processText(node.title, decisionTree.context)" />
    </template>
    <template #body>
      <BaseHtmlContent class="node__message" :html="processText(node.message, decisionTree.context)" />
      <BaseTextField v-model="node.noteText" />
    </template>
  </BaseNode>
</template>

<script setup>
import { useSnippetProcessor } from "#/decision_tree_viewer/composables/useSnippetProcessor";

const props = defineProps({
  node: {
    type: Object,
    required: true,
  },
  decisionTree: {
    type: Object,
    required: true,
  },
});

const { processText } = useSnippetProcessor();
</script>
